import axios from 'axios'

import { HttpService } from './http.service'
import { IWhiteLabelOverrides } from 'src/types'

class WhiteLabelService extends HttpService {
  constructor() {
    super(axios)
  }

  getOverrides(whiteLabelId: string, locale: string) {
    return this.get<IWhiteLabelOverrides>(`white-label/${whiteLabelId}/overrides/${locale}`)
  }
}

export const whiteLabelService = new WhiteLabelService()


